module.exports = __webpack_public_path__ + "img/IS.116172be.svg";